import { OrderRejectionReason } from '../../../../../services/exports/Constants';

export default {
  header: 'Cancel order',
  title: 'Never reject too lightly!',
  text: 'If there’s a minor issue with the order, please call the customer and work it out.',
  reasons: {
    [OrderRejectionReason.ItemUnavailable]: 'Items out of stock',
    [OrderRejectionReason.ClosingSoon]: 'Store is closed',
    [OrderRejectionReason.StoryBusy]: 'Store is too busy',
    [OrderRejectionReason.CustomerMistake]: 'Customer called to cancel',
    [OrderRejectionReason.DriverNotArrived]: 'Driver not arrived',
  },
  buttons: {
    confirm: 'Confirm',
  },
};
